import { Box, Button, Typography } from "@material-ui/core";
import React, { createRef, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useQuery } from "react-query";
import useLocale from "../../../hooks/useLocale";
import { fetchApplicationKinds } from "../../../services/applicationKindsService";
import ApplicationInfo from "./ApplicationInfo";
import styled from "styled-components/macro";

const InfoWrapper = styled(Box)`
  height: calc(100vh - 21rem);
  overflow-y: auto;
`;
const ApplicationKindsWrapper = styled(Box)`
  margin-bottom: 2rem;
`;

const StyledButton = styled(Button)`
  &:hover {
    background-color: transparent;
  }
  span {
    text-decoration: underline;
  }
`;
function ApplicationsInfo() {
  const { t } = useLocale();

  const { data: applicationKinds } = useQuery(
    "applicationKinds",
    fetchApplicationKinds
  );

  const handleClick = (kind) => {
    document.getElementById(`${kind}`).scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Helmet title={t("Application Info")} />
      <Typography variant="h6" style={{ marginBottom: "1rem" }}>
        {t("Choose appplication kind to view the associated info")}
      </Typography>
      <ApplicationKindsWrapper>
        {applicationKinds?.map((application, index) => {
          return (
            <StyledButton
              key={application?.id}
              onClick={() => handleClick(application?.dscr)}
              variant="text"
            >
              {application.dscr}
            </StyledButton>
          );
        })}
      </ApplicationKindsWrapper>
      <InfoWrapper>
        {applicationKinds?.map((application, index) => {
          return (
            <ApplicationInfo
              key={application?.id}
              title={application?.dscr}
              info={application?.details}
            />
          );
        })}
      </InfoWrapper>
    </>
  );
}

export default ApplicationsInfo;
